import React from "react";
import { Col as BSCol } from "react-bootstrap";
import { classNames } from "../utils/classNames";
export const Col = (props) => {
    return React.createElement(BSCol, { ...props });
};
export const LeftCol = ({ children }) => (React.createElement(Col, { sm: 4 }, children));
export const CentreCol = ({ children, full, }) => (React.createElement(Col, { sm: full ? 12 : 8 }, children));
export const RightCol = ({ children }) => (React.createElement("div", { className: "layout--panel" }, children));
export const LayoutContainer = ({ children }) => (React.createElement("div", { className: "layout--content content-container" }, children));
export const Page = ({ children, className = "", }) => (React.createElement("div", { className: classNames("page", className) }, children));
